function select(holder, selector, type, idx = 0) {
  const nodes = holder.childNodes.filter(
    node =>
      node.classNames && node.classNames.trim().split(/\s+/).includes(selector),
  )

  if (type === SELECTOR_TYPE.ARRAY) return nodes || []

  if (!nodes || !Array.isArray(nodes) || nodes.length === 0) {
    return type === SELECTOR_TYPE.NODE ? null : ``
  }

  if (type === SELECTOR_TYPE.NODE) return nodes[idx] || null

  if (type === SELECTOR_TYPE.SEARCHIE_VIDEO) {
    let searchieVideo = null
    const searchieVideoNode = nodes[idx]
    if (searchieVideoNode) {
      const searchieVideoAnchor = searchieVideoNode.childNodes[0]
      if (searchieVideoAnchor && searchieVideoAnchor.attributes)
        searchieVideo = searchieVideoAnchor.attributes.href || null
    }
    return searchieVideo
  }

  const node = nodes[idx]
  if (!node) return ``

  return node[type]
}

const SELECTOR_TYPE = {
  NODE: `node`,
  ARRAY: `array`,
  TEXT: `text`,
  INNER_HTML: `innerHTML`,
  OUTER_HTML: `outerHTML`,
  SEARCHIE_VIDEO: `searchieVideo`,
}

module.exports.ChildSelector = {
  select,
  SELECTOR_TYPE,
}
